"use client";
/** The one share dialog, mounted in AppShell beside the preview overlay; any surface opens it through useShareDialogStore. */
import { useShareDialogStore } from "@/stores/shareDialogStore";
import { ShareDialog } from "./ShareDialog";

export function ShareDialogHost() {
  const target = useShareDialogStore((s) => s.target);
  const close = useShareDialogStore((s) => s.close);
  return target ? (
    <ShareDialog key={target.id} target={target} onClose={close} />
  ) : null;
}
